import React from "react";
import ItemList from "../components/ItemList";

function Tacos() {
  const IMG_TACO =
    "https://i.pinimg.com/564x/9e/74/89/9e7489eef92a52b00185b978e46d9aba.jpg";

  const tacos = [
    {
      key: "casablanca",
      name: "Taco Casablanca",
      price: "6,00€",
      ingredients:
        "Pollo o ternera, carne kebab, lechuga, tomate, cebolla, patatas fritas y salsa yogourt",
    },
    {
      key: "pizza",
      name: "Taco Pizza",
      price: "7,00€",
      ingredients:
        "Con salsa de tomate, pollo, carne kebab, lechuga, tomate, cebolla, patatas fritas y salsa yogourt",
    },
    {
      key: "york",
      name: "Taco York",
      price: "7,00€",
      ingredients:
        "York, pollo o ternera, carne kebab, lechuga, tomate, cebolla, patatas fritas y salsa yogourt",
    },
    {
      key: "pepperoni",
      name: "Taco Pepperoni",
      price: "7,00€",
      ingredients:
        "Pepperoni, carne kebab, pollo o ternera, lechuga, tomate, cebolla, patatas fritas y salsa yogourt",
    },
    {
      key: "bacon",
      name: "Taco Bacon",
      price: "7,00€",
      ingredients:
        "Bacon, pollo o ternera, carne kebab, lechuga, tomate, cebolla, patatas fritas y salsa yogourt",
    },
  ].map((t) => ({
    ...t,
    img: IMG_TACO,
    description: t.ingredients,
    menuPrice: null,
    menuIncludes: null,
  }));

  return (
    <div id="tacos" className="container mx-auto mt-8 px-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Tacos Gratinados</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tacos.map((item) => (
          <ItemList
            key={item.key}
            name={item.name}
            description={item.description}
            price={item.price}
            img={item.img}
            menuPrice={item.menuPrice}
            menuIncludes={item.menuIncludes}
          />
        ))}
      </div>
    </div>
  );
}

export default Tacos;